// extracted by mini-css-extract-plugin
export default {"parent":"paymentPrice_parent__Fj2Up","hvacLabel":"paymentPrice_hvacLabel__71s-L","hvacCheckbox":"paymentPrice_hvacCheckbox__Wqifh","hvacInfo":"paymentPrice_hvacInfo__h63r3"};